import { fetchLoginCall } from "../ajax";
import { API_CONSTANTS, API_METHODS } from "../api-constant";

export const GetHealthProfessionalDashboardData = async () => {
  const url = `${API_CONSTANTS.GET_HP_DASHBOARD_DATA}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const GetAdminDashboardData = async () => {
  const url = `${API_CONSTANTS.GET_ADMIN_DASHBOARD_DATA}`;
  return fetchLoginCall(url, API_METHODS.GET);
};
